import React, { HTMLAttributes } from 'react';
import truncate from 'truncate-markup-string';

import {
  Container,
  Quote,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  ImmutableEntity,
} from '@uncinc/react-drupal-core/types';

import './style.scss';
import { ParagraphQuote as Type } from '../../../types/uncinc_profile/paragraphs';

interface ParagraphQuoteProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphQuote: React.FC<ParagraphQuoteProps> = ({
  entity,
}) => {
  const paragraphQuote = entity.toJS();

  const uuid = paragraphQuote.uuid[0].value;
  const writer = paragraphQuote.field_name[0].value;
  const quote = paragraphQuote.field_body[0].processed || '';
  const profileImage = paragraphQuote.field_media_item[0]?.entity?.field_media_image[0].source;
  const position = paragraphQuote.field_label[0]?.value;
  const QUOTE_MAX_CHARS = 500;

  return (
    <div id={uuid} className="ParagraphQuote">
      <Container>
        <Quote
          writer={writer}
          quote={truncate(quote, QUOTE_MAX_CHARS, '<span>', '</span>', true)}
          // TODO: Apply correct breakpoints from constants/variables.
          profileImage={profileImage}
          position={position}
        />
      </Container>
    </div>
  );
};

export default ParagraphQuote;
